module.exports = __webpack_public_path__ + "img/1013.8b74ebe9.png";